// fields/SocialMediaFields.js
import React from "react";
import { Col, Row } from "antd";
import MetaTitleField from "./MetaTitleField";
import MetaDescriptionField from "./MetaDescriptionField";
import ImageUploadField from "./ImageUploadField";

const SocialMediaFields = () => {
  return (
    <Row gutter={16}>
      {/* Open Graph Fields */}
      <Col lg={8} md={12} sm={24} xs={24}>
        <MetaTitleField
          name="og_title"
          label="Open Graph Title"
          maxLength={60}
          required={false}
        />
      </Col>
      <Col lg={8} md={12} sm={24} xs={24}>
        <MetaDescriptionField
          name="og_description"
          label="Open Graph Description"
          maxLength={160}
          required={false}
        />
      </Col>
      <Col lg={8} md={24} sm={24} xs={24}>
        <ImageUploadField
          name="og_image"
          label="Open Graph Image"
          required={false}
        />
      </Col>

      {/* Twitter Fields */}
      <Col lg={8} md={12} sm={24} xs={24}>
        <MetaTitleField
          name="twitter_title"
          label="Twitter Title"
          maxLength={70}
          required={false}
        />
      </Col>
      <Col lg={8} md={12} sm={24} xs={24}>
        <MetaDescriptionField
          name="twitter_description"
          label="Twitter Description"
          maxLength={200}
          required={false}
        />
      </Col>
      <Col lg={8} md={24} sm={24} xs={24}>
        <ImageUploadField
          name="twitter_image"
          label="Twitter Image"
          required={false}
        />
      </Col>
    </Row>
  );
};

export default SocialMediaFields;
